import { render } from "./TrendView.vue?vue&type=template&id=4aaa7a60"
import script from "./TrendView.vue?vue&type=script&lang=js"
export * from "./TrendView.vue?vue&type=script&lang=js"

import "./TrendView.vue?vue&type=style&index=0&id=4aaa7a60&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__